import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {PMEIsQuery_procedureMethodExecutionInstances_ProcedureMethodExecutionInstanceNode as PMEI} from 'procedures/worksheets/__generated/PMEIsQuery';

/**
 * Determine whether material outputs of the PMEI are all confirmed
 *
 * Note that this function should be kept in-sync with the backend validation function:
 * benchling/procedures/integrations/processes/create_method_tasks_outputs_helpers.py:validate_material_output_confirmations
 * @param worksheet Worksheet query data
 * @returns boolean indicating whether all material outputs are confirmed
 */
export function areMaterialOutputsConfirmed(pmei: PMEI | null): {
  areConfirmed: boolean;
  unconfirmedIds: Array<string>;
} {
  if (!pmei || isInaccessible(pmei)) {
    return {areConfirmed: false, unconfirmedIds: []};
  }

  if (isInaccessible(pmei.planMethodDefinitionVersion)) {
    return {areConfirmed: false, unconfirmedIds: []};
  }

  const materialOutputSettings = pmei.planMethodDefinitionVersion.materialOutputSettings;
  const materialOutputConfirmationValues = pmei.materialOutputConfirmationValues;

  const materialOutputSettingsVersionIds = materialOutputSettings.map((mos) => mos.version.id);
  const materialOutputConfirmationValuesVersionIds = materialOutputConfirmationValues.map(
    (mocv) => mocv.materialOutputVersion.id
  );
  const unconfirmedMaterialOutputVersionIds = materialOutputSettingsVersionIds.filter(
    (mosvi) => !materialOutputConfirmationValuesVersionIds.includes(mosvi)
  );

  if (unconfirmedMaterialOutputVersionIds.length > 0) {
    return {areConfirmed: false, unconfirmedIds: unconfirmedMaterialOutputVersionIds};
  }
  return {areConfirmed: true, unconfirmedIds: []};
}

export function areAllMaterialOutputsConfirmed(pmeis: Array<PMEI | null>): boolean {
  return pmeis.every((pmei) => areMaterialOutputsConfirmed(pmei).areConfirmed);
}
